export const JOURNAL_ENTRY = "v1/post-journal-entries";